import React, {useCallback, useEffect, useState} from 'react';
import {useIntegrationsContext} from "../../api/integrations/IntegrationsContext";
import {useHistory, useParams} from "react-router";
import {AppField} from "../ui/AppField";
import {makeStyles} from "@mui/styles";
import {Loader} from "../ui/Loader";
import {showError} from "../../utils/NotificationUtils";
import {AppButton} from "../ui/AppButton";
import {toast} from "react-toastify";

const useStyles = makeStyles(() => ({
    root: {
        "& ~ .app-header": {
            display: "none !important" as any
        },
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "auto"
    },
    container: {
        maxWidth: 440,
        width: "100%",
        margin: "0 auto",
        padding: 20,
        maxHeight: "70%",
        overflow: "auto"
    },
    fieldRoot: {
        marginBottom: 20
    },
    btnsRoot: {
        display: "flex",
        justifyContent: "center",
        gap: 20
    }
}));

export function CreateConnection() {
    const classes = useStyles();
    const {IntegrationsApi} = useIntegrationsContext();
    const [loading, setLoading] = useState(true);
    const [values, setValues] = useState({});
    const [data, setData] = useState<any[]>([]);
    const [name, setName] = useState<string>("Account Name");
    const [submitting, setSubmitting] = useState(false);
    const params: any = useParams();
    const history = useHistory();
    useEffect(() => {
        IntegrationsApi.getIntegrationAuth({params: {integrationId: params.integrationId}}).then(res => {
            if (res.payload.authType !== "BASIC_AUTH") {
                setData(res.payload.fields);
                setName(res.payload.integration.name);
                setValues(prev => {
                    let obj = {};
                    res.payload.fields?.forEach((item: any) => {
                        //@ts-ignore
                        obj[item.code] = ""
                    });
                    return {...prev, ...obj}
                })
            } else {
                setData([
                    {
                        "id": Date.now() + Math.random() * 30,
                        "label": "Email",
                        "code": "email",
                        "type": "STRING",
                        "description": "",
                        "defaultValue": "",
                        "required": true
                    },
                    {
                        "id": Date.now() + Math.random() * 30,
                        "label": "Password",
                        "code": "password",
                        "type": "PASSWORD",
                        "description": "",
                        "defaultValue": "",
                        "required": true
                    },
                ]);

                setValues(prev => {

                    return {
                        email: "",
                        password: ""
                    }
                })
            }
            setLoading(false)
        }).catch(err => {
            showError(err);
            setLoading(false)
        })
    }, [IntegrationsApi, params]);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        let requiredFieldsNotFilled: boolean = false;
        Object.keys(values).forEach((item: string) => {
            const requiredFields = data.filter(x => x.code === item);
            // @ts-ignore
            if (requiredFields[0].required && values[item].length === 0) {
                // @ts-ignore
                requiredFieldsNotFilled = true
            }
        });
        if (requiredFieldsNotFilled || name.length === 0) {
            toast.error("Please fill required fields")
        } else {
            setSubmitting(true);
            console.log(values);
            IntegrationsApi.createConnection({data: {
                    fields: {...values},
                    integrationId: params.integrationId,
                    name: name
                }}).then((res) => {
                toast.success("Successfully Created");
                toast.loading("Closing...");
                setTimeout(() => {
                    window.opener.postMessage("success", "https://qa-connector.kpi.com/")
                    window.close();
                }, 1000);
                setSubmitting(false)
            }).catch(err => {
                showError(err);
                setSubmitting(false)
            })
        }

    }, [IntegrationsApi, values, data, history, name, params]);


    return (
        <div className={classes.root}>
            <div className={classes.container}>
                {loading ? (
                    <Loader/>
                ) : (
                    <form onSubmit={handleSubmit}>
                        {
                            data && data.map(item => (
                                <div key={item.id} className={classes.fieldRoot}>
                                    <AppField
                                        name={item.code}
                                        id={item.code}
                                        type={item.type}
                                        labelText={item.label}
                                        required={item.required}
                                        onChange={(e: any) => setValues(prev => ({
                                            ...prev,
                                            [item.code]: e.target.value
                                        }))}
                                    />
                                </div>
                            ))
                        }
                        <div className={classes.fieldRoot}>
                            <AppField
                                name="name"
                                id="name"
                                type="string"
                                value={name}
                                labelText="Connection Name"
                                required={true}
                                onChange={(e: any) => setName(e.target.value)}
                            />
                        </div>
                        <div className={classes.btnsRoot}>
                            <AppButton type="submit" disabled={submitting} loading={submitting}>Yes, Continue</AppButton>
                            <AppButton background="#e3e3e3" disabled={submitting} textColor="#000" onClick={() => {
                                window.opener.postMessage("cancel", "https://qa-connector.kpi.com/")
                            }}>Cancel</AppButton>
                        </div>
                    </form>
                )

                }
            </div>
        </div>
    );
}

